export const FEATURE_KEYS = {
  META_OFFICIAL: "meta_official_integrations",
  WHATSAPP_META: "whatsapp_official_meta",
  INSTAGRAM_DIRECT: "instagram_direct",
  FACEBOOK_MESSENGER: "facebook_messenger",
  EXTERNAL_INTEGRATIONS: "external_integrations",
  API_KEYS: "api_keys",
  WEBHOOKS: "webhooks",
  API_DOCS: "api_docs",
  ADVANCED_CHANNEL_SETTINGS: "advanced_channel_settings",
};

const SUPER_ADMIN_ALIASES = new Set([
  "super_admin",
  "superadmin",
  "super-admin",
  "platform_admin",
  "platform-admin",
  "platformadmin",
]);

export function normalizeRole(role) {
  const raw = String(role || "").trim().toLowerCase().replace(/-/g, "_");
  if (SUPER_ADMIN_ALIASES.has(raw) || SUPER_ADMIN_ALIASES.has(raw.replace(/_/g, "-"))) {
    return "super_admin";
  }
  return raw;
}

export function getFeatureMap(user) {
  return user?.features && typeof user.features === "object" ? user.features : {};
}

export function isSuperAdmin(user) {
  return normalizeRole(user?.role) === "super_admin";
}

export function hasFeature(user, feature) {
  if (!feature) return false;
  if (isSuperAdmin(user)) return true;
  return Boolean(getFeatureMap(user)[feature]);
}

export function hasAnyFeature(user, features = []) {
  if (isSuperAdmin(user)) return true;
  const list = Array.isArray(features) ? features : [];
  return list.some((feature) => hasFeature(user, feature));
}
